(() => {
  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const findProductInfo = (element) => element.closest('product-info');

  const syncFinishToVariant = (widget, finish) => {
    const productInfo = findProductInfo(widget);
    const picker = productInfo?.querySelector('variant-selects');
    if (!picker) return;

    const radio = Array.from(picker.querySelectorAll('input[type="radio"][data-option-name]')).find(
      (input) => normalize(input.dataset.optionName) === 'plating' && normalize(input.value) === normalize(finish)
    );

    if (radio) {
      if (radio.checked) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const select = Array.from(picker.querySelectorAll('select')).find((control) =>
      Array.from(control.options).some(
        (option) => normalize(option.dataset.optionName) === 'plating' && normalize(option.value) === normalize(finish)
      )
    );

    if (select && normalize(select.value) !== normalize(finish)) {
      const option = Array.from(select.options).find((candidate) =>
        normalize(candidate.dataset.optionName) === 'plating' && normalize(candidate.value) === normalize(finish)
      );
      if (!option) return;
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const syncFinishToOwnPrint = (productInfo, finish) => {
    const widget = productInfo.querySelector('.ownprint-personalization');
    if (!widget) return;
    const swatch = Array.from(widget.querySelectorAll('[data-ownprint-swatch]')).find(
      (button) => normalize(button.dataset.ownprintSwatch) === normalize(finish)
    );
    if (swatch && swatch.getAttribute('aria-checked') !== 'true') swatch.click();
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element
      ? event.target.closest('.ownprint-personalization [data-ownprint-swatch]')
      : null;
    if (!target) return;

    const finish = target.dataset.ownprintSwatch;
    window.setTimeout(() => syncFinishToVariant(target, finish), 0);
  });

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || !target.matches('input[type="radio"][data-option-name]')) return;
    if (normalize(target.dataset.optionName) !== 'plating') return;
    const productInfo = findProductInfo(target);
    if (productInfo) syncFinishToOwnPrint(productInfo, target.value);
  });
})();